module.exports = __webpack_public_path__ + "img/trans-skill.2639d24c.svg";